import React, { FC } from 'react';
import { Row } from 'components/Grid/Grid';
import { Text } from 'components/Typography';
import { Icon, TIconNames } from 'components/Icon';
import { Colors, FontWeights } from 'core/CssVariables';

type TProps = {
  onClick: () => void;
};

const AddContactDropdownAction: FC<TProps> = ({ onClick }) => (
  <Row
    align="middle"
    style={{ padding: '4px 12px', cursor: 'pointer' }}
    onClick={onClick}
  >
    <Icon
      icon={TIconNames.PERSON_ADD}
      size={16}
      color={Colors.PrimaryColor}
      className="mr-1"
    />
    <Text
      fontlevel={5}
      fontWeight={FontWeights.Medium}
      color={Colors.PrimaryColor}
    >
      Add new contact
    </Text>
  </Row>
);

export { AddContactDropdownAction };
